/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { ControlValueAccessorDirective } from '@sharedModule/directives/control-value-accessor.directive';
import { InputData } from '@sharedModule/models/input-data.model';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrl: './input-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSelectComponent),
      multi: true,
    },
  ],
})
export class InputSelectComponent<T> extends ControlValueAccessorDirective<T> {
  @Input() inputData!: InputData;
  @Input() selectOptions!: any[] | null;
  @Input() bindLabel!: string;
  @Input() bindValue!: string;
  @Output() selectionChange = new EventEmitter<{
    value: any;
    selectOptions: any[] | null;
  }>();

  onValueChange(event: MatSelectChange, selectOptions: any[] | null): void {
    this.selectionChange.emit({
      value: event.value,
      selectOptions: selectOptions,
    });
  }
}
